import Adapter from './adapter'

function getEndpoint(config, defaultConfig) {
  if (!config && !defaultConfig) {
    throw new Error('No config provided');
  }

  if (!config?.endpointConfig && !defaultConfig?.endpointConfig) {
    throw new Error('No endpointConfig provided');
  }

  let endpointConfig = config?.endpointConfig;
  let defaultEndpointConfig = defaultConfig?.endpointConfig;
  if (typeof endpointConfig === 'string') return endpointConfig;
  if (typeof defaultEndpointConfig === 'string') return defaultEndpointConfig;

  if (endpointConfig && endpointConfig.endpoint) {
    return endpointConfig.endpoint;
  }

  if (defaultEndpointConfig && defaultEndpointConfig.endpoint) {
    return defaultEndpointConfig.endpoint;
  }

  endpointConfig = endpointConfig || {};
  defaultEndpointConfig = defaultEndpointConfig || {};

  const isv = endpointConfig.isv || defaultEndpointConfig.isv || 'kd';
  const app = endpointConfig.app || defaultEndpointConfig.app;
  const source = endpointConfig.source || defaultEndpointConfig.source;
  const version = endpointConfig.version || defaultEndpointConfig.version || 'v1';
  const sourceId = endpointConfig.sourceId || defaultEndpointConfig.sourceId;
  const subSource = endpointConfig.subSource || defaultEndpointConfig.subSource;
  const action = endpointConfig.action || defaultEndpointConfig.action;

  if (!app) {
    throw new Error('Invalid config app provided');
  }

  if (!source) {
    throw new Error('Invalid config source provided');
  }

  let result = `${location.pathname}kwc/${version}/${isv}/${app}/${source}`
  if (sourceId) {
    result += `/${sourceId}`

    if (subSource) {
      result += `/${subSource}`
    }

    if (action) {
      result += `/${action}`
    }
  }

  if (!result.startsWith('/')) {
    result = `/${result}`
  }

  return result
}

function createAdapterMethod(defaultMethod = 'GET', defaultConfig = {}) {
  return function adapterFactory(dataCallback) {
    if (typeof dataCallback !== 'function') {
      throw new Error('Adapter API expects a data callback function');
    }

    const adapter = new Adapter(dataCallback);

    const originalUpdate = adapter.update.bind(adapter);
    adapter.update = function (config) {
      const fullConfig = {
        endpoint: getEndpoint(config, defaultConfig),
        method: defaultMethod,
        ...defaultConfig,
        ...config
      }
      delete fullConfig.endpointConfig;

      if (config && typeof config === 'object' && !config.endpoint) {
        fullConfig.params = config.params;
      }

      return originalUpdate(fullConfig);
    }

    // 注：适配器方式不提供取消能力；如需取消请使用 promiseApi。

    return adapter;
  }
}

export const doGet = createAdapterMethod('GET')
export const doPost = createAdapterMethod('POST')
export const doDelete = createAdapterMethod('DELETE')
export const doPut = createAdapterMethod('PUT')
export const doPatch = createAdapterMethod('PATCH')